import * as React from 'react';
import { Alert } from 'reactstrap';

/**
 * Success Props
 */
interface SuccessProps {
	message: string;
}

/**
 * Reusable Success Alert Component used by AdminErrorBoundary and Listing/Tree base components.
 *
 * @class Success
 * @extends {React.Component<any, any>}
 */
class Success extends React.Component<SuccessProps, any> {
	constructor(props: SuccessProps) {
		super(props);
	}

	public render() {
		return (
			<Alert color="success" data-testid="alert-success">
				<h4>Success!</h4>
				{this.props.message}
			</Alert>
		);
	}
}

export default Success;
